// Shaderhost thing.
import * as THREE from "three";
import * as dat from 'dat.gui';
import { Host } from "../engine/host";
import { AClock } from "../engine/clock";
import { TextureStore } from "../engine/utils";
import { preload } from "../engine/loader";
import { FullScreenQuadEntity } from "../engine/entity";
class SHost {
    resources() {
        return {
            'models': [],
            'shaders': this.shaders,
            'gltf': [],
            'textures': []
        };
    }
    constructor(f_client) {
        // Add some basic dat.GUI controls for managing uniforms
        this.gui = new dat.GUI();
        this.aclock = new AClock();
        this.dTime = 0.0;
        this.target = null;
        this.mousePos = new THREE.Vector2(0,0);
        this.camera = null;
        this.mouseDown = false;
        this.shaders = [
            {
                "path": "v_basic.glsl",
                "name": "v_basic"
            },
            {
                "path": f_client,
                "name": "f_client"
            },
            {
                "path": "f_basic.glsl",
                "name": "f_basic"
            },
            {
                "path": "globals.glsl",
                "name": "globals"
            }
        ];
        this.entities = [];
        this.uniforms = {
            xPosition: {
                type: 'f',
                value: 0.0
            },
            yPosition: {
                type: 'f',
                value: 0.0
            },
            zPosition: {
                type: 'f',
                value: 0.0
            },
            scaleFactor: {
                type: 'f',
                value: 10000.0
            },
            spriteTilesWide: {
                type: 'f',
                value: 1.0
            },
            spriteTilesTall: {
                type: 'f',
                value: 1.0
            },
            spriteIndexX: {
                type: 'f',
                value: 0.0
            },
            spriteIndexY: {
                type: 'f',
                value: 0.0
            },
            spriteIndex: {
                type: 'f',
                value: 0.0
            },
            time: {
                type: 'f',
                value: 0.0
            },
            noiseMult: {
                type: 'f',
                value: 10.0
            },
            wireframe: {
                type: 'i',
                value: 0
            },
            color: {
                type: 'v3',
                value: new THREE.Vector3()
            },
            flatColor: {
                type: 'v3',
                value: new THREE.Color(0x000000)
            },
            diffuse: {
                type: 'c',
                value: new THREE.Color(0xaaeeff)
            },
            resolution: {
                type: 'v2',
                value: new THREE.Vector2()
            },
            mouse: {
                type: 'v2',
                value: new THREE.Vector2()
            },
            lightPosition: {
                type: 'v3',
                value: new THREE.Vector3()
            },
            cameraPos: {
                type: 'v3',
                value: new THREE.Vector3()
            },
            t0: {
                type: 't',
                value: TextureStore.getTexture('dogs')
            }
        };
    }
    // finally add a damn quad.
    addQuad() {
        let width = 2;
        let height = 3;
        let quad = new QuadEntity(
            this.scene,
            width,
            height,
            'v_basic',
            'f_luts');
        quad.setTexture('pattern-1');
        quad.uniforms.resolution.value.x = 128;
        quad.uniforms.resolution.value.y = 128;
        this.entities.push(quad);
        return quad;
    }
    setup(_sceneWidth, _sceneHeight) {
        this.sceneWidth = _sceneWidth;
        this.sceneHeight = _sceneHeight;
        this.uniforms.resolution.value.x = _sceneWidth;
        this.uniforms.resolution.value.y = _sceneHeight;
        this.scene = new THREE.Scene();
        this.camera = new THREE.PerspectiveCamera(67,
            _sceneWidth / _sceneHeight,
            0.001,
            1e20);
        let light = new THREE.AmbientLight(0xffffff);
        this.scene.add(light);
        this.camera.position.z = 30;
        // Adds the full screen quad
        this.quad = new FullScreenQuadEntity(this.scene,
            this.camera,
            this.sceneWidth,
            this.sceneHeight,
            'v_basic',
            'f_client');
        this.quad.uniforms.resolution.value.x = this.sceneWidth;
        this.quad.uniforms.resolution.value.y = this.sceneHeight;
        this.entities.push(this.quad);
    }
    // With just a raymarcher drawing becomes weird.
    handleMouse(e) {
        if (e.type === 'mousedown') {
            this.mouseDown = true;
        }
        if (e.type === 'mouseup') {
            this.mouseDown = false;
        }
        if ( e.type === 'mousemove') {
            if (this.mouseDown) {
                this.mousePos = new THREE.Vector2(e.x, e.y);
            }
        }
    }
    render(renderer) {
        this.aclock.update();
        this.uniforms["time"].value = this.aclock.dMS;
        this.uniforms.resolution.value.x = this.sceneWidth;
        this.uniforms.resolution.value.y = this.sceneHeight;
        renderer.render(this.scene, this.camera);
        for (let e of this.entities) {
            e.update(this.aclock);
        }
        this.quad.uniforms.mouse.value = this.mousePos;
    }
}
document.addEventListener("DOMContentLoaded", function (event) {
    // Global shader is external
    if (!globalShader) {
        console.log("You must set a global shader");
        return;
    }
    let shost = new SHost(globalShader);
    preload([shost], function () {
        const host = new Host(shost);
        host.setup();
    });
});
